module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-catch-links@5.15.0_gatsby@5.15.0_babel-eslint@10.1.0_eslint@9.39.1_jiti@2.6.1___ci7vozaj2nxqffxlq3uqrht2vi/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-google-tagmanager@5.16.0_gatsby@5.15.0_babel-eslint@10.1.0_eslint@9.39.1_jiti@2_fnj2vuhyyjmy4jqoaboufhleje/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-NC88HQM","includeInDevelopment":false,"defaultDataLayer":{"type":"object","value":{"platform":"gatsby"}},"enableWebVitalsTracking":true,"routeChangeEventName":"gatsby-route-change","selfHostedOrigin":"https://www.googletagmanager.com","selfHostedPath":"gtm.js"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.15.0_babel-eslint@10.1.0_eslint@9.39.1_jiti@2.6.1___esbuild@0.25.12_react-dom@18.2.0_2d2cukor7qyqf4ju32vik2lw6q/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
